import React from "react";
import { connect } from "react-redux";

/*
  STEP 11: We will still be using the props in mapStateToProps, and the functions in mapDispatchToProps, without extra
  customisations, so we can import them directly from core ProfileDrawerContainer.js
*/
import {
  mapStateToProps,
  mapDispatchToProps,
  ProfileDrawerContainer
} from "components/ProfileDrawer/ProfileDrawerContainer";
import ProfileDrawer from "components/ProfileDrawer/ProfileDrawer";

import { SINGLE_PROJECT_APP, ENABLE_INBOX } from "config";

/*
  STEP 10: We will be removing the floating buttons from the page. To do so, we need the ProfileDrawerContainer.js or ProfileDrawer.js
  to understand that it will not have profile drawer when (1) it is in the Project page, (2) when the Project ID is 3377.

  Likewise, we wouldn't want to do this by modifying `get profileDrawerState()` in Pages.js. If you look at the `mapStateToProps`
  function in core ProfileDrawerContainer.js, we have this.props.profileDrawer and this.props.projectId ready for us to check
  for the 2 conditions.

  If you would check against the console.log of the Redux store in index.js, you will realize the profileDrawer key in Redux is
  an object, which houses the state of the profileDrawer, as profileDrawer.state. Checking against `get profileDrawerState()`
  function in Pages.js, you will see that Topic Category and Project pages will return "project".
*/
export class CustomProfileDrawerContainer extends ProfileDrawerContainer {
  render() {
    const IS_MOBILE_PROJECT_PAGE =
      this.state.isMobilePage && this.props.profileDrawer.state === "project";

    if (
      this.props.profileDrawer.state === "no-profile-drawer" ||
      IS_MOBILE_PROJECT_PAGE ||
      (this.props.projectId === 3377 &&
        this.props.profileDrawer.state === "project")
    ) {
      return null;
    } else {
      return (
        <ProfileDrawer
          user={this.props.user}
          projectId={this.props.projectId}
          project={this.props.project}
          notifications={this.props.notifications || 0}
          inboxUnread={this.props.inboxUnread || 0}
          points={this.props.points || 0}
          loggedIn={this.isLoggedIn()}
          singleProjectApp={SINGLE_PROJECT_APP}
          // passing in ENABLE_INBOX as a prop for Jest tests
          enableInbox={ENABLE_INBOX}
          language={this.props.language}
        />
      );
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CustomProfileDrawerContainer);
